document.addEventListener('DOMContentLoaded', function() {
  // Wait for images to load before initializing Swiper
  const images = document.querySelectorAll('.compare-tables-swiper img');
  let loadedImages = 0;

  function initSwiper() {
    const compareTablesSwiper = new Swiper('.compare-tables-swiper', {
      slidesPerView: 2,
      spaceBetween: 10,
      autoHeight: false,
      loop: true,
      observer: true,
      observeParents: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          enabled: true
        },
        320: {
          slidesPerView:  2,
          enabled: true
        }
      },
      on: {
        init: function() {
          initScrollListener();
          updateBannerText();
        },
        slideChange: function() {
          updateBannerText();
        }
      }
    });

    // Handle floating navigation buttons
    const prevButton = document.querySelector('.floating-nav-button--prev');
    const nextButton = document.querySelector('.floating-nav-button--next');

    if (prevButton && nextButton) {
      prevButton.addEventListener('click', () => {
        compareTablesSwiper.slidePrev();
      });

      nextButton.addEventListener('click', () => {
        compareTablesSwiper.slideNext();
      });
    }
  }

  function updateBannerText() {
    setTimeout(() => {
      const activeSlide = document.querySelector('.swiper-slide-active');
      const banner = document.querySelector('.floating-banner');
      
      if (activeSlide && banner) {
        const titleWrapper = activeSlide.querySelector('.title-wrappers');
        if (titleWrapper) {
          // Clone the title wrapper to avoid modifying the original
          const clonedTitleWrapper = titleWrapper.cloneNode(true);
          // Clear the banner and append the cloned title wrapper
          banner.innerHTML = '';
          banner.appendChild(clonedTitleWrapper);
        }
      }
    }, 200);
  }

  function initScrollListener() {
    const slider = document.querySelector('.compare-tables-swiper');
    const navButtons = document.querySelector('.floating-nav-buttons');
    
    if (!slider || !navButtons) return;

    const checkScroll = () => {
      const rect = slider.getBoundingClientRect();
      const scrollThreshold = rect.height * 0.05;
      const exitThreshold = rect.height * 0.2; // Increased to 20% to hide earlier
      const scrolled = window.scrollY;
      const sliderTop = rect.top + scrolled;
      const sliderBottom = sliderTop + rect.height;
      
      // Check if we're within the slider bounds (minus exit threshold)
      if (scrolled > sliderTop + scrollThreshold && scrolled < sliderBottom - exitThreshold) {
        navButtons.classList.add('visible');
      } else {
        navButtons.classList.remove('visible');
      }
    };

    window.addEventListener('scroll', checkScroll);
    // Initial check
    checkScroll();
  }

  // Initialize Swiper after a short delay to ensure DOM is ready
  setTimeout(initSwiper, 100);
}); 